import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import { DraftNewPatch } from "$src/domain/projects/drafts/DraftNewPatch";
import { DraftPermission } from "$src/domain/projects/drafts/DraftPermission";
import { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { NewDraft } from "$src/domain/projects/drafts/NewDraft";
import { PatchResult } from "$src/domain/projects/drafts/PatchResult";
import { ProjectDraft } from "$src/domain/projects/drafts/ProjectDraft";
import { ApiRoutes } from "$src/infrastructure/apiConfig/ApiRoutes";
import { BaseApi } from "$src/infrastructure/apiConfig/BaseApi";
import { injectable } from "tsyringe";

@injectable()
export class ProjectDraftRepositoryApi extends BaseApi implements IProjectDraftRepository {
    
    protected static getRoute(groupStoreId: string, projectId: string, path: string | undefined = undefined) : string {
        if( path )
            return `${ApiRoutes.PROJECTS.DRAFTS.endpoint(groupStoreId, projectId)}/${path}`;
        else
            return `${ApiRoutes.PROJECTS.DRAFTS.endpoint(groupStoreId, projectId)}`;
    }
    
    public async RequestDraft(groupStoreId: number, projectId: number): Promise<DraftPermission> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.post(route, undefined);
        } catch (error) {
            console.error('Error requesting project draft', error);
            throw error; 
        }
    }

    public async TakeOverDraft(groupStoreId: number, projectId: number): Promise<DraftPermission> {
        try {
            console.log('before posting to ');

            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), 'takeover');
            
            console.log('posting to ', route);

            return await this.apiClient.post(route, undefined);
        } catch (error) {
            console.error('Error taking over project draft', error);
            throw error; 
        }
    }

    public async GetDraft(groupStoreId: number, projectId: number): Promise<ProjectDraft> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.get(route);
        } catch (error) {
            console.error('Error getting project draft', error);
            throw error; 
        }
    }
    
    public async PatchDraft(groupStoreId: number, projectId: number, patch: DraftNewPatch): Promise<PatchResult> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.patch(route, patch);
        } catch (error) {
            console.error('Error patching project draft', error);
            throw error; 
        }
    }

    public async OverrideDraft(groupStoreId: number, projectId: number, newDraft: NewDraft): Promise<DraftIdentifier> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.put(route, newDraft);
        } catch (error) {
            console.error('Error overriding project draft', error);
            throw error; 
        }
    }

    public async DeleteDraft(groupStoreId: number, projectId: number): Promise<DraftIdentifier> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.delete(route);
        } catch (error) {
            console.error('Error deleting project draft', error);
            throw error; 
        }
    }

    public async PublishDraft(groupStoreId: number, projectId: number): Promise<DraftIdentifier> {
        try {
            const route = ProjectDraftRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), 'publish');
            
            return await this.apiClient.post(route, undefined);
        } catch (error) {
            console.error('Error publising project draft', error);
            throw error; 
        }
    }
}